import * as products from '../../products';
export const getProductId = name => {
  const product = Object.values(products).find(prod => (prod === null || prod === void 0 ? void 0 : prod.name) === name);
  return product && 'id' in product && product.id ? String(product.id) : null;
};
//# sourceMappingURL=getProductId.js.map